import Table from 'rc-table'
import styled from 'styled-components/macro'

export const TableNoMinHeight = styled(Table)`
  min-height: auto;
`
